/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import { getParamValueFromUrl } from '../../core/utils';

import type { BaseRequestData } from '../../interfaces';

const getDevelopmentHeaders = (): Record<string, string> => {
    const productVersionHeader = 'x-product-version';
    const productVersion = `v${(process.env.VERSION || '').split('.')[0]}`;
    const userRoleHeader = 'x-user-role';
    const userRole = `${getParamValueFromUrl('userRole')}`;

    return {
        [productVersionHeader]: productVersion,
        [userRoleHeader]: userRole,
    };
};

const clearBaseRequestFieldsFromData = (data?: Record<string, any> & BaseRequestData): Record<string, any> => {
    if (data && data.hasOwnProperty('disableGlobalFilters')) {
        delete data.disableGlobalFilters;
    }

    if (data && data.hasOwnProperty('rcopAutoUpdate')) {
        delete data.rcopAutoUpdate;
    }

    return data;
};

export {
    getDevelopmentHeaders,
    clearBaseRequestFieldsFromData,
};
